<template>
    <div :class="theme.tariffCard">
        <v-text type="subheadling">
            {{ title }}
        </v-text>
        <div>
            <v-text type="title" light>
                <slot></slot>
            </v-text>
        </div>
    </div>
</template>
<script>
    import theme from './theme.scss';

    export default {
        name: 'tariff-card',
        props: {
            title: String,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TariffCard.vue?d81ffa5c